// extracted by mini-css-extract-plugin
module.exports = {"Chart":"Chart_Chart__16rof","ChartContent":"Chart_ChartContent__17_jF","PlayersAndRounds":"Chart_PlayersAndRounds__3zqY7","ArrowBack":"Chart_ArrowBack__3RZW0"};